
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/straps/all",
      function () {
        return require("private-next-pages/[lang]/straps/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/straps/all"])
      });
    }
  